var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9941 20.9925V18.9932C15.9941 17.9327 15.5728 16.9157 14.8229 16.1658C14.073 15.4159 13.056 14.9946 11.9955 14.9946H5.9976C4.93711 14.9946 3.92006 15.4159 3.17018 16.1658C2.4203 16.9157 1.99902 17.9327 1.99902 18.9932V20.9925",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99663 10.9961C11.205 10.9961 12.9952 9.20583 12.9952 6.99748C12.9952 4.78913 11.205 2.9989 8.99663 2.9989C6.78827 2.9989 4.99805 4.78913 4.99805 6.99748C4.99805 9.20583 6.78827 10.9961 8.99663 10.9961Z",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9921 20.9925V18.9933C21.9914 18.1073 21.6966 17.2467 21.1538 16.5464C20.611 15.8462 19.851 15.3461 18.9932 15.1246",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9941 3.12891C16.8543 3.34913 17.6166 3.84935 18.161 4.55071C18.7054 5.25207 19.0009 6.11468 19.0009 7.00253C19.0009 7.89039 18.7054 8.75299 18.161 9.45435C17.6166 10.1557 16.8543 10.6559 15.9941 10.8762",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers4);
export default __webpack_public_path__ + "static/media/Users4.4e69632779af303b62c6bee19f9a7966.svg";
export { ForwardRef as ReactComponent };